import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { CertificateTemplateDataDTO } from "../../schema/Certificate/CertificateTemplateDataDTO";
import { CretificateTemplateQueryParamsDTO } from "../../schema/Certificate/CretificateTemplateQueryParamsDTO";
import { GetDataDTO } from "../../schema/Common/GetDataDTO";
import { ContactUsTO } from "../../schema/Subscriptions/ContactUsTO";
import { EmailSuporteTO } from "../../schema/Subscriptions/EmailSuporteTO";
import { SubscriptionDTO } from "../../schema/Subscriptions/SubscriptionDTO";

@Injectable({
    providedIn: "root"
})
export class ApiSubscriptionsService {
    constructor(private http: HttpClient) {}

    public ContactUs(
        cardData: ContactUsTO,
        userId: string,
        userName: string,
        userEmail: string
    ): Observable<EmailSuporteTO> {
        const email: EmailSuporteTO = {
            idUsuario: userId,
            nomeUsuario: userName,
            assunto: cardData.subject,
            mensagem: cardData.message,
            emailUsuario: userEmail
        };

        return this.http.post<EmailSuporteTO>(
            `${environment.subscriptions.url}/api/v1/Susbcriptions/Public/contact-us`,
            email
        );
    }

    public GetSubscriptionByHost(host: string): Observable<SubscriptionDTO> {
        return this.http.get<SubscriptionDTO>(
            `${environment.subscriptions.url}/api/v1/Susbcriptions/Public?host=${host}`
        );
    }

    public GetCertificateTemplates(
        query: CretificateTemplateQueryParamsDTO,
        subscriptionId: string
    ): Observable<GetDataDTO<CertificateTemplateDataDTO>> {
        let params = new HttpParams().set("skip", query.skip.toString()).set("take", query.take.toString());

        if (query.find) params = params.set("find", query.find);
        if (query.sortOrder) params = params.set("SortOrder", query.sortOrder);
        if (query.orderBy) params = params.set("OrderBy", query.orderBy);

        if (query.active != null) params = params.set("active", query.active.toString());

        return this.http.get<GetDataDTO<CertificateTemplateDataDTO>>(
            `${environment.subscriptions.url}/api/v1/subscription/${subscriptionId}/certificate/template`,
            { params: params }
        );
    }

    public GetCertificateTemplate(id: string, subscriptionId: string): Observable<CertificateTemplateDataDTO> {
        return this.http.get<CertificateTemplateDataDTO>(
            `${environment.subscriptions.url}/api/v1/subscription/${subscriptionId}/certificate/template/${id}`
        );
    }
}
